import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  findingCard: {
    padding: theme.spacing(1.5),
    backgroundColor: theme.palette.background.default,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    marginTop: theme.spacing(1),
  },
  findingTitle: {
    marginBottom: theme.spacing(0.75),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.75),
  },
  findingTitleText: {
    fontSize: '0.78rem',
    fontWeight: 600,
    color: theme.palette.text.primary,
    lineHeight: 1,
  },
  findingSubLabel: {
    fontSize: '0.68rem',
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
    color: theme.palette.text.secondary,
    fontWeight: 600,
    marginTop: theme.spacing(0.75),
  },
  findingText: {
    fontSize: '0.82rem',
    color: theme.palette.text.primary,
    lineHeight: 1.5,
  },
  overlayBadge: {
    fontSize: '0.65rem',
    height: 18,
    backgroundColor: theme.palette.action.selected,
    color: theme.palette.text.primary,
  },
  evidencesRow: {
    display: 'flex',
    gap: theme.spacing(0.5),
    flexWrap: 'wrap',
  },
}))

export default useStyles
